<template>
  <div class="title-tag-row flex">
    <div
      v-for="(tag, index) in row"
      :key="index"
      :class="index ? 'tag cell-size' : 'cell-size'"
      class="bg-caramel-tertiary-900"
    >
      {{ $t(tag) }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['row'],
}
</script>
